export type PromoPlacement =
  | 'site_banner'
  | 'pricing'
  | 'dashboard_sidebar'
  | 'billing'
  | 'email_onboarding';

export interface PromoBase {
  code: string;
  offerLabel: string;       // primary headline/badge text
  supportingCopy: string;   // single-line body
  terms?: string;           // short legal/supporting note
  badge?: string;
  discountPercent?: number; // optional numeric discount for UI price display
}

type PromoOverride = Partial<PromoBase> & { disabled?: boolean };

interface PromoConfig extends PromoBase {
  active: boolean;
  disableBasePromo?: boolean;
  refOverrides?: Record<
    string,
    {
      base?: PromoOverride;
    }
  >;
}

const baseConfig: PromoConfig = {
  active: true,
  disableBasePromo: false,
  code: 'UTMPartner40',
  badge: 'Early Access Partner',
  offerLabel: '40% Lifetime Discount.',
  supportingCopy: 'Early Access Partners receive a 40% discount on every renewal for Pro, Team, and Agency plans.',
  terms: 'The discount remains active for as long as your Pro, Team, or Agency subscription stays active.',
  discountPercent: 40,
  refOverrides: {
    producthunt: {
      base: {
        code: 'PHUNT40',
        badge: 'Product Hunt Backers',
        offerLabel: '40% Lifetime Discount.',
        supportingCopy: 'Product Hunt users receive a 40% lifetime discount on all renewals for Pro, Team, and Agency plans.',
        discountPercent: 40,
      },
    },
  },
};

export const promoConfig = baseConfig;

export const getPromoCopy = (
  placement: PromoPlacement,
  options?: { ref?: string | null }
): PromoBase | null => {
  if (!promoConfig.active) {
    return null;
  }

  const { refOverrides, disableBasePromo, active, ...baseFields } = promoConfig;

  const normalizedRef = options?.ref?.toLowerCase().trim();
  const refOverride = normalizedRef ? refOverrides?.[normalizedRef] : undefined;
  const refBase = refOverride?.base;

  // If any override layer explicitly disables this placement, skip.
  if (refBase?.disabled) {
    return null;
  }

  // Optionally require a ref override to show any promo
  if (disableBasePromo && !refOverride) {
    return null;
  }

  const payload: PromoBase = {
    ...baseFields,
  };

  if (refBase) Object.assign(payload, refBase);

  return payload;
};
